import { ArrowBack, DeleteOutlined, SaveOutlined } from "@mui/icons-material";
import { Autocomplete, Box, Checkbox, Divider, Stack, TextField, Typography } from "@mui/material";
import { ImagePlus, Trash2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../../components";
import { ErrorScreen } from "../../../components/error-screen";
import { Loading } from "../../../components/loading";
import { useToastStore, useUserStore } from "../../../stores";
import { colorPrimary, textFieldStyle } from "../../../theme";
import { formatDateFromISO, formatHourFromISO, maskCurrencyBRL, maskPlaca } from "../../../utils/mask/MaskUtils";
import { AutoCompleteField } from "../components/AutoComplete";
import { TextFieldController } from "../components/TextFieldComponent";
import { AcessoriosDTO, CompanyDTO, CriarVeiculoAnuncioDTO, MarcasFormDTO, ModelosFormDTO, NewAdsOrVeichleForm, VehicleImage } from "../dto/CompanyDTO";
import { formatCurrency, getCombustivel, getCombustivelId, getImageSrc, getSelectedAcessorios, getTransmissaoId, getTransmissaoLabel, parseCurrencyToDecimal } from "../helpers/ComapnyHelpers";
import { acessoriosMock, combustiveis, transmissao, typeOfVehicle } from "../mocks/CompanyMocks";
import { createVehicle, deletePhoto, fetchAdById, fetchCompanies, fetchFipe, fetchMarcas, fetchModelo, updatePhotoCapa } from "../repository/ComapnyRepository";


export function CreateOrUpdateVehicleTab() {
  const navigate = useNavigate();
  const { user } = useUserStore();
  const { adId } = useParams();
  const isEdit = adId !==null;
  const { setToast } = useToastStore();
  const jaCarregouRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [companies, setCompanies]= useState<CompanyDTO [] | null>(null);
 const {
  control,
  handleSubmit,
  formState: { errors },
  reset,
  setValue,
} = useForm<NewAdsOrVeichleForm>({ defaultValues: {
      companyId: null,
      placa: null,
      tipo_veiculo: null,
      marca: null,
      modelo: null,
      anoFabricacao: null,
      anoModelo: null,
      km: null,
      motor: null,
      combustivel: null,
      transmissao: null,
      cor: null,
      portas: null,
      data_anuncio_finalizacao: null,
      hora_finalizacao_anuncio: null,
      data_leilao_finalizacao: null,
      hora_leilao_finalizacao_anuncio: null,
      valor_inicial: null,
      valor_compre_agora: null,
      texto_padrao: null,
      observacao: null,
      avarias: null,
    },});
  const [laudoFile, setLaudoFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [images, setImages] = useState<VehicleImage[]>([]);
  const photosInputRef = useRef<HTMLInputElement | null>(null);
  const [acessorios, setAcessorios] = useState<AcessoriosDTO[]>(acessoriosMock);
  const [marcas, setMarcas]= useState<MarcasFormDTO[]>([]);
  const [modelos, setModelos]= useState<ModelosFormDTO[]>([]);
  const [laudo, setLaudoLink] = useState<string | null>(null);
  const selectedTypeOfVehicle = useWatch({
  control,
  name: "tipo_veiculo",
  });
const [vehicleLocked, setVehicleLocked] = useState(false);
const [selectedMarcaId, setSelectedMarcaId] = useState<number | null>(null);
const [selectedModeloObj, setSelectedModeloObj] = useState<ModelosFormDTO | null>(null);

const handleOpenPhotosDialog = () => {
  photosInputRef.current?.click();
};

const handleRemovePhoto = async (indexToRemove: number) => {
  const image = images[indexToRemove];

  //  IMAGEM NOVA (File) → só remove local
  if (image.isNew) {
    if (image.previewUrl) {
      URL.revokeObjectURL(image.previewUrl);
    }

    setImages((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );

    return;
  }

  //  IMAGEM EXISTENTE (API)
  try {
    setLoading(true);

    await deletePhoto(
      image.adId!,
      image.url!
    );

    setImages((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  } catch (error) {
setToast({message:"Erro. Contate o administrador", variant:"error"}); 
  } finally {
    setLoading(false);
  }
};

const handleSetCover =async (index: number) => {
  const image = images[index];
  if (image.isNew) {
      setImages((prev) =>
    prev.map((img, i) => ({
      ...img,
      isCapa: i === index,
    }))
  );
  return;
  }
  try {
    const result = await updatePhotoCapa(image.adId!,Number(adId),image.url!);
    if (result ===true) {
  setImages((prev) =>
      prev.map((img, i) => ({
        ...img,
        isCapa: i === index,
      }))
    );
    }
  } catch (error) {
    console.error(error);
    setToast({message:"Erro. Contate o administrador", variant:"error"});
  } finally {
    setLoading(false);
  }

};



 const handleToggleAcessorio = (id: number) => {
  setAcessorios((prev) =>
    prev.map((item) =>
      item.id === id
        ? { ...item, isActive: !item.isActive }
        : item
    )
  );
};


const handleSelectPhotosInput = (
  e: React.ChangeEvent<HTMLInputElement>) => {
  const files = Array.from(e.target.files ?? []);

  setImages((prev) => {
    const hasCover = prev.some((i) => i.isCapa);

    const mapped: VehicleImage[] = files.map((file, index) => ({
      file,
      previewUrl: URL.createObjectURL(file),
      isNew: true,
      isCapa: !hasCover && index === 0,
    }));

    return [...prev, ...mapped];
  });
};




const handleOpenFileDialog = (e?: React.MouseEvent) => {
  e?.preventDefault();
  e?.stopPropagation();
  fileInputRef.current?.click();
};

const handleSelectLaudo = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  const file = event.target.files?.[0] ?? null;
  setLaudoFile(file);
};

const handleClearVehicle = () => {
  setValue("tipo_veiculo", null);
  setValue("marca", null);
  setValue("modelo", null);
  setMarcas([]);
  setModelos([]);
  setSelectedMarcaId(null);
  setSelectedModeloObj(null);
  setVehicleLocked(false);
};

const fetchCompanie = async () => {
  try {
    const userId = user?.id;
    const result = await fetchCompanies(userId);
    if (!result?.success) {
      return;
    }
    setCompanies(result.data);
  } catch (error) {
  }
}

const fetchModelos = async (marcaId: number) => {
  try {
    setLoading(true);
    const result = await fetchModelo(marcaId);
    if (!result?.success) {
    setToast({message:result.message??"Erro. Contate o administrador", variant:"error"});
      return;
    }
    setModelos(result.data);
  } catch {
setToast({message:"Erro. Contate o administrador", variant:"error"});
  } finally {
    setLoading(false);
  }
};
const getMarcas = async (typeVehicleId: number) => {
  try {
    setLoading(true);

    const result = await fetchMarcas(typeVehicleId);

    if (!result?.success) {
      setToast({message:result.message??"Erro. Contate o administrador", variant:"error"});
      return;
    }

    setMarcas(result.data);
  } catch {
    setToast({message:"Erro. Contate o administrador", variant:"error"});
  } finally {
    setLoading(false);
  }
};


const onSubmitAds = async (data: NewAdsOrVeichleForm) => {
  setLoading(true);

  try {
    const fotos = images
      .filter(img => img.isNew && img.file)
      .map(img => ({
        foto: img.file as File,
        capa: img.isCapa,
      }));

    if (fotos.length === 0) {
      setToast({
        message: "Informe ao menos uma foto do veículo",
        variant: "error",
      });
      setLoading(false);
      return;
    }
    const codigoFipe = selectedModeloObj?.codigo_fipe?.trim() ?? "";
    const valorFipe = codigoFipe ? await fetchFipe(codigoFipe, Number(data.anoModelo)) : null;
    const payload: CriarVeiculoAnuncioDTO = {
      id_concessionaria: Number(data.companyId),

      placa: data.placa ?? "",
      tipo_veiculo: String(data.tipo_veiculo),
      marca: data.marca ?? "",
      modelo: data.modelo ?? "",

      ano_fabricacao: Number(data.anoFabricacao) ?? 0,
      ano_modelo: Number(data.anoModelo) ?? 0,
      km: Number(data.km) ?? 0,
      codigo_fipe: codigoFipe,
      valor_fipe: valorFipe,
      motor: data.motor ?? "",
      combustivel: getCombustivel(data.combustivel) ?? "",
      transmissao: getTransmissaoLabel(data.transmissao) ?? "",
      cor: data.cor ?? "",
      portas: Number(data.portas),

      valor: parseCurrencyToDecimal(data.valor_inicial),

      observacao: data.observacao ?? "",
      avarias: data.avarias ?? null,

      laudo_file: laudoFile,

      acessorios: getSelectedAcessorios(acessorios),
      fotos, 
    };

    const result = await createVehicle(payload);

    if (!result?.success) {
      setToast({
        message: result.message ?? "Erro. Contate o administrador.",
        variant: "error",
      });
      return;
    }

    setToast({
      message: result.message ?? "Veículo cadastrado com sucesso",
      variant: "success",
    });

    window.history.back();
  } catch {
    setToast({
      message: "Erro. Contate o administrador.",
      variant: "error",
    });
  } finally {
    setLoading(false);
  }
};

const preloadAdData = async (anuncioId: number) => {
  try {
    setLoading(true);

   const data = await fetchAdById(anuncioId);

    if (!data.data.id) return;
        const anuncio = data.data;
  const transmissaoId =   getTransmissaoId(anuncio.transmissao);
  const combustivelId = getCombustivelId(anuncio.combustivel);
  setLaudoLink(anuncio.laudo);
    setVehicleLocked(true);
    reset({
      companyId: anuncio.concessionaria_id,
      placa: anuncio.placa,
      tipo_veiculo: anuncio.tipo_veiculo, 
      marca: anuncio.marca ?? "",
      modelo: anuncio.modelo ?? "",
      anoFabricacao: String(anuncio.num_ano_fabricacao),
      anoModelo: String(anuncio.num_ano_modelo),
      km: anuncio.km,
      motor: anuncio.motor,
      combustivel: combustivelId, // mapearemos abaixo
      transmissao: transmissaoId,
      laudo: anuncio.laudo,
      cor: anuncio.cor,
      portas: anuncio.portas,
      data_anuncio_finalizacao: formatDateFromISO(anuncio.dat_finalizacao),
      hora_finalizacao_anuncio: formatHourFromISO(anuncio.dat_finalizacao),
      data_leilao_finalizacao: anuncio.data_leilao
        ? formatDateFromISO(anuncio.data_leilao)
        : null,
      hora_leilao_finalizacao_anuncio: anuncio.data_leilao
        ? formatHourFromISO(anuncio.data_leilao)
        : null,
      valor_inicial:formatCurrency(anuncio.val_inicial),
      valor_compre_agora: formatCurrency(anuncio.val_compre_agora),
      texto_padrao: anuncio.texto_padrao,
      observacao: anuncio.observacao,
      avarias: anuncio.avarias,
    });

    //  Acessórios
    setAcessorios((prev) =>
      prev.map((a) => ({
        ...a,
        isActive: anuncio.acessorios.includes(a.id),
      }))
    );

    //  Fotos existentes (URLs)
    setImages(
      anuncio.fotos.map((file: string) => ({
        url: `${file}`,
        isNew: false,
      adId: adId
      }))
    );

  } catch (error) {
    console.error(error);
setToast({message:"Erro. Contate o administrador", variant:"error"});
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  if (jaCarregouRef.current) return;

  jaCarregouRef.current = true;
  fetchCompanie();

  if (isEdit && adId) {
    preloadAdData(Number(adId));
  }
}, [isEdit, adId]);


useEffect(() => {
  if (!selectedTypeOfVehicle || vehicleLocked) return;
  getMarcas(selectedTypeOfVehicle);
  setValue("marca", null);
  setValue("modelo", null);
  setSelectedMarcaId(null);
  setSelectedModeloObj(null);
  setModelos([]);
}, [selectedTypeOfVehicle, vehicleLocked]);

useEffect(() => {
  if (!selectedMarcaId) return;
  fetchModelos(selectedMarcaId);
}, [selectedMarcaId]);




  if (loading) return <Loading fullScreen={true} />;
  if (error) return <ErrorScreen fullScreen />;
 


    return (
      <>
<Box display="flex" flexDirection="column" width="100%" height="100%" gap={4} >
<form onSubmit={handleSubmit(onSubmitAds)}>
  {/* FORMULÁRIO NOVO ANÚNCIO */}
  <Box
    display="grid"
    gridTemplateColumns="repeat(2, 1fr)"
    gap={4}
    flexGrow={1}
    width="100%"
  >
  <Box borderRadius={1} p={2} gap={1} bgcolor="white">
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Dados do veículo *
      </Typography>
      <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
      <Box
        display="grid"
        gridTemplateColumns="repeat(1, 1fr)"
        gap={2}
        width="100%"
      >
      <AutoCompleteField
        name="companyId"
        control={control}
        errors={errors}
        options={companies ?? []}
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="placa"
        label="Placa"
        title="Placa"
        placeholder="Ex: ABC-1234"
        required
        mask={maskPlaca}
      />
      <AutoCompleteField
        control={control}
        errors={errors}
        name="tipo_veiculo"
        label="Escolha o tipo de veículo"
        required={true}
        title="Tipo de veículo"
        options={typeOfVehicle}
        disabled={vehicleLocked}
      />
      <Controller
        name="marca"
        control={control}
        rules={{ required: "Marca é obrigatória" }}
        render={({ field }) => (
          <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
            <Typography fontWeight={400} width="400px">Marca</Typography>
            <Autocomplete<MarcasFormDTO, false, false, true>
              freeSolo
              fullWidth
              disabled={vehicleLocked}
              options={marcas}
              getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
              inputValue={field.value ?? ""}
              onInputChange={(_, value, reason) => {
                if (reason === 'input' || reason === 'clear') {
                  field.onChange(value || null);
                  setSelectedMarcaId(null);
                  setModelos([]);
                  setValue("modelo", null);
                  setSelectedModeloObj(null);
                }
              }}
              onChange={(_, newValue) => {
                if (typeof newValue === 'string') {
                  field.onChange(newValue || null);
                  setSelectedMarcaId(null);
                } else if (newValue) {
                  field.onChange(newValue.label);
                  setSelectedMarcaId(newValue.id);
                } else {
                  field.onChange(null);
                  setSelectedMarcaId(null);
                }
                setValue("modelo", null);
                setModelos([]);
                setSelectedModeloObj(null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={textFieldStyle}
                  label="Escolha a marca do veículo"
                  placeholder="marca do veículo"
                  error={!!errors?.marca}
                  helperText={errors?.marca?.message as string | undefined}
                />
              )}
            />
          </Stack>
        )}
      />
      <Controller
        name="modelo"
        control={control}
        rules={{ required: "Modelo é obrigatório" }}
        render={({ field }) => (
          <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
            <Typography fontWeight={400} width="400px">Modelo</Typography>
            <Autocomplete<ModelosFormDTO, false, false, true>
              freeSolo
              fullWidth
              disabled={vehicleLocked}
              options={modelos}
              getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
              inputValue={field.value ?? ""}
              onInputChange={(_, value, reason) => {
                if (reason === 'input' || reason === 'clear') {
                  field.onChange(value || null);
                  setSelectedModeloObj(null);
                }
              }}
              onChange={(_, newValue) => {
                if (typeof newValue === 'string') {
                  field.onChange(newValue || null);
                  setSelectedModeloObj(null);
                } else if (newValue) {
                  field.onChange(newValue.label);
                  setSelectedModeloObj(newValue);
                } else {
                  field.onChange(null);
                  setSelectedModeloObj(null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={textFieldStyle}
                  label="Escolha o modelo do veículo"
                  placeholder="modelo do veículo"
                  error={!!errors?.modelo}
                  helperText={errors?.modelo?.message as string | undefined}
                />
              )}
            />
          </Stack>
        )}
      />
      {vehicleLocked && (
        <Stack direction="row" justifyContent="flex-end" mt={1}>
          <Button variant="text" type="button" onClick={handleClearVehicle}>
            <DeleteOutlined fontSize="small" />
            <span>Limpar veículo</span>
          </Button>
        </Stack>
      )}
      <TextFieldController
        control={control}
        errors={errors}
        name="anoFabricacao"
        label="Ano de fabricação"
        title="Ano de fabricação"
        placeholder="Informe o ano de fabricação. Ex: 2025"
        required
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="anoModelo"
        label="Ano modelo"
        title="Ano modelo"
        placeholder="Informe o ano do modelo. Ex: 2026" 
        required
      />
      </Box>
  </Box>
  <Box borderRadius={1} p={2} gap={1} bgcolor="white">
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Propriedades do veículo *
      </Typography>
      <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
      <Box
        display="grid"
        gridTemplateColumns="repeat(1, 1fr)"
        gap={2}
        width="100%"
      >
      <TextFieldController
        control={control}
        errors={errors}
        name="km"
        label="Informe a quilometragem"
        title="Quilometragem"
        placeholder="Ex: 161.200"
        required
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="motor"
        title="Motor"
        label="Motor"
        placeholder="Informe o motor. Ex: 2.2"
        required
      />
      <AutoCompleteField
        control={control}
        errors={errors}
        name="combustivel"
        label="Escolha o combustível"
        required={true}
        title="Combustível"
        options={combustiveis ?? []}
      />
      <AutoCompleteField
        control={control}
        errors={errors}
        label="Escolha a transmissão"
        name="transmissao"
        required={true}
        title="Transmissão"
        options={transmissao ?? []}
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="cor"
        title="Cor"
        label="Cor"
        placeholder="Informe a cor do veículo. Ex: branca"
        required
      />
      <TextFieldController
        control={control}
        errors={errors}
        name="portas"
        label="Portas"
        title="Número de portas"
        placeholder="Informe a quantidade de portas." 
        required
      />
      </Box>
    </Box>
  </Box>
  <Box
    display="grid"
    gridTemplateColumns="repeat(2, 1fr)"
    gap={4}
    flexGrow={1}
    mt={2}
    width="100%"
  >
  <Box borderRadius={1} p={2} gap={1} bgcolor="white">

      <Box
        display="grid"
        gridTemplateColumns="repeat(1, 1fr)"
        gap={2}
        width="100%"
      >
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Valores *
      </Typography>
      <Divider sx={{ width: "100%", my:0, borderBottomWidth: 2 }} />
      <TextFieldController
        control={control}
        errors={errors}
        name="valor_inicial"
        label="Valor do veículo"
        title="Valor do veículo"
        placeholder="R$ 50.000,00"
        required
        mask={maskCurrencyBRL}
      />
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Observações *
      </Typography>
      <Divider sx={{ width: "100%", my: 0, borderBottomWidth: 2 }} />
      <Controller
        name="observacao"
        control={control}
        rules={{ required: "Texto padrão é obrigatório" }}
        render={({ field }) => (
        <TextField
          {...field}
          sx={textFieldStyle}
          fullWidth
          multiline
          rows={4}
          label="Observações essenciais"
          placeholder="Escreva observações relevantes sobre o veículo para aparecer na 
tela do anúncio de cotação."
          error={!!errors?.placa}
          helperText={errors?.placa?.message}
        />
        )}
      />
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Avarias *
      </Typography>
      <Divider sx={{ width: "100%", my: 0, borderBottomWidth: 2 }} />
      <Controller
        name="avarias"
        control={control}
        rules={{ required: "Avarias padrão é obrigatório" }}
        render={({ field }) => (
        <TextField
          {...field}
          sx={textFieldStyle}
          fullWidth
          multiline
          rows={4}
          label="Avarias & Defeitos"
          placeholder="Escreva possíveis avarias do veículo."
          error={!!errors?.placa}
          helperText={errors?.placa?.message}
        />
        )}
      />
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
      >
        Laudo *
      </Typography>
      <Divider sx={{ width: "100%", my: 0, borderBottomWidth: 2 }} />
      <Box
        mt={2}
        p={2}
        borderRadius={2}
        display="flex"
        alignItems="center"
        flexDirection={"column"}
        gap={2}
        bgcolor="white"
        border="1px solid #dee2e6"
      >
        <input
          ref={fileInputRef}
          type="file"
          accept="application/pdf"
          hidden
          onChange={handleSelectLaudo}
        />
        <Stack display={"flex"} flexDirection={"column"} gap={2} alignContent={"flex-start"} justifyContent={"flex-start"} alignItems={"center"}>
                  <Button
          variant="contained"
          type="button"
          onClick={(e) => handleOpenFileDialog(e)}
        >
          Selecionar arquivo
        </Button>

        <Typography
          fontSize="0.9rem"
          color={laudoFile ? "black" : "text.secondary"}
        >
          {laudoFile
            ? laudoFile.name
            : laudo ?"Observação: Ao realizar o upload de um novo laudo e clicar no botão salvar, o laudo anterior será substituído." : "Nenhum arquivo selecionado"}
        </Typography>
        </Stack>
        {adId && !laudoFile && (
          <a
            href={laudo?.includes('hmlv2api.avaliadordigital')? laudo : `https://www.canaldorepasse.com.br/anuncios/fotos/${adId}/${laudo}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Typography
              fontWeight={400}
              fontSize="1rem"
              color={colorPrimary}
              sx={{ cursor: "pointer" }}
            >
              Visualizar Laudo cautelar
            </Typography>
          </a>
        )}
      </Box>
<Typography
  fontWeight="bold"
  fontSize="1.3rem"
  color="black"
  mt={2}
>
  Fotos do veículo *
</Typography>

<Divider sx={{ width: "100%", my: 0, borderBottomWidth: 2 }} />

{/* INPUT ESCONDIDO */}
<input
  ref={photosInputRef}
  type="file"
  accept="image/*"
  multiple
  hidden
  onChange={handleSelectPhotosInput}
/>

<Box
  mt={2}
  p={4}
  borderRadius={2}
  display="flex"
  flexDirection="column"
  alignItems="center"
  justifyContent="center"
  gap={1}
  bgcolor="white"
  border="2px dashed #dee2e6"
  sx={{
    cursor: "pointer",
    transition: "all .2s ease",
    "&:hover": {
      borderColor: colorPrimary,
      backgroundColor: "rgba(255, 102, 0, 0.04)",
    },
  }}
  onClick={handleOpenPhotosDialog}
>
  <ImagePlus size={40} color={colorPrimary} />

  <Typography
    fontWeight={600}
    fontSize="0.95rem"
    color="black"
  >
    Adicionar fotos
  </Typography>

  <Typography
    fontSize="0.8rem"
    color="text.secondary"
  >
    {images.length > 0
      ? `${images.length} foto(s) selecionada(s)`
      : "Clique para selecionar uma ou mais fotos"}
  </Typography>
</Box>
{images.length > 0 && (
  <Box
    mt={2}
    display="grid"
    gridTemplateColumns="repeat(auto-fill, minmax(120px, 1fr))"
    gap={2}
  >
    {images.map((image, index) => {
      const src = getImageSrc(image);

      return (
        <Box
          key={`${image.url ?? image.file?.name}-${index}`}
          position="relative"
          borderRadius={2}
          overflow="hidden"
          border="1px solid #dee2e6"
          sx={{
            cursor: "pointer",
            "&:hover .overlay": {
              opacity: 1,
            },
          }}
        >
          {/* IMAGEM */}
          <img
            src={src}
            alt="Foto do veículo"
            style={{
              width: "100%",
              height: "120px",
              objectFit: "cover",
              display: "block",
            }}
          />
          {/* BADGE CAPA */}
          {image.isCapa && (
            <Box
              position="absolute"
              top={8}
              left={8}
              px={1}
              py={0.3}
              borderRadius={1}
              bgcolor={colorPrimary}
              color="white"
              fontSize="0.7rem"
              fontWeight={600}
              zIndex={2}
            >
              CAPA
            </Box>
          )}
          {/* OVERLAY */}
{/* OVERLAY */}
<Box
  className="overlay"
  position="absolute"
  display="flex"
  alignItems="center"
  justifyContent="center"
  gap={2}
  bgcolor="rgba(0,0,0,0.55)"
  sx={{
    inset: 0,
    opacity: 0,
    transition: "opacity .2s ease",
  }}
>

  {/* DEFINIR CAPA */}
  {!image.isCapa && (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        handleSetCover(index);
      }}
      sx={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all .2s ease",
        "&:hover": {
          backgroundColor: colorPrimary,
          color: "#fff",
        },
      }}
      title="Definir como capa"
    >
      ⭐
    </Box>
  )}

  {/* REMOVER */}
  <Box
    onClick={(e) => {
      e.stopPropagation();
      handleRemovePhoto(index);
    }}
    sx={{
      width: 40,
      height: 40,
      borderRadius: "50%",
      backgroundColor: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all .2s ease",
      "&:hover": {
        backgroundColor: "#d32f2f",
        color: "#fff",
      },
    }}
    title="Remover foto"
  >
    <Trash2 size={20} />
  </Box>
</Box>

          {/* NOME / STATUS */}
          <Typography
            fontSize="0.7rem"
            p={0.5}
            noWrap
            bgcolor="white"
            title={image.file?.name ?? image.url}
          >
            {image.file?.name ?? "Imagem cadastrada"}
          </Typography>
        </Box>
      );
    })}
  </Box>
)}

    </Box>
  </Box>
  <Box borderRadius={1} p={2} gap={1} bgcolor="white">
      <Typography
        fontWeight="bold"
        fontSize="1.3rem"
        color="black"
        mt={2}
        mb={1}
      >
        Acessórios do veículo *
      </Typography>
      <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
      <Box
        mt={2}
        display="grid"
        gridTemplateColumns="repeat(2, 1fr)"
        gap={1}
        width="100%"
      >
        {acessorios.map((item) => (
          <Box
            key={item.id}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <Checkbox
              checked={item.isActive}
              onChange={() => handleToggleAcessorio(item.id)}
              sx={{
                color: "#dee2e6",
                "&.Mui-checked": {
                  color: colorPrimary,
                },
              }}
            />

            <Typography
              fontSize="0.95rem"
              color="black"
            >
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>
  </Box>
  </Box>
  <Stack display={"flex"} flexDirection={"row"} mt={2} flexGrow={1} justifyItems={"center"} alignContent={"center"} alignItems={"center"} justifyContent={"flex-end"} gap={2}>
    <div>
  <Button
    variant='text'
    onClick={() => {
      navigate("/anuncios");
    }}
    type='button'
  >
    <ArrowBack fontSize='medium' />
    <span>Voltar</span>
  </Button>
    </div>
  <Button
  fitContent={true}
  variant="large"
  type="submit"
  >
  <SaveOutlined fontSize='medium' />
  Salvar
  </Button>
  </Stack>
  </form>
</Box>
    </>
    );
}

